// The server trims a person's name and refuses it when nothing is left (PersonName,
// QA 2026-09-29 bug 3), answering with a raw 422 ("body.first_name: String should have
// at least 1 character"). Every form that sends a name checks it here first, so the user
// reads a sentence instead (bug 4).
export function blankNameMessage(firstName, lastName) {
  if (!firstName.trim()) return 'First name is required';
  if (!lastName.trim()) return 'Last name is required';
  return '';
}
